import type { ComponentProps, FC } from 'react';
import { Link, useLocation, useNavigate } from 'react-router';
import { Button } from './Button';

type Props = {
  type?: ComponentProps<typeof Button>['type'];
  path: string;
  text: string;
  disabled?: boolean;
  asLink?: boolean;
  fullPath?: boolean;
};

export const NavigateButton: FC<Props> = ({
  type = 'primary',
  disabled,
  path,
  text,
  asLink,
  fullPath,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const url = fullPath ? path : `${location.pathname}/${path}`;

  return asLink ? (
    <Link to={url} tabIndex={-1}>
      <Button type={type} disabled={disabled}>
        {text}
      </Button>
    </Link>
  ) : (
    <Button
      onClick={() => {
        navigate(url);
      }}
      type={type}
      disabled={disabled}
    >
      {text}
    </Button>
  );
};
